(() => {
  const root = document.querySelector('.cu-article-page');
  const body = root?.querySelector('#ArticleBody');
  if (!body) return;
  const toc = root.querySelector('.article-toc');
  const links = root.querySelector('[data-article-jump-links]');
  body.querySelectorAll('h2,h3').forEach((heading, index) => {
    if (!heading.textContent.trim()) return;
    if (!heading.id || document.querySelectorAll(`[id="${CSS.escape(heading.id)}"]`).length > 1) {
      let id = `article-section-${index + 1}`;
      while (document.getElementById(id)) id += '-heading';
      heading.id = id;
    }
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    if (!heading.hasAttribute('tabindex')) heading.tabIndex = -1;
    link.addEventListener('click', () => heading.focus({ preventScroll: true }));
    links.append(link);
  });
  if (links.children.length) {
    toc.hidden = false;
    const desktop = window.matchMedia('(min-width: 992px)');
    toc.open = desktop.matches;
    desktop.addEventListener('change', () => { toc.open = desktop.matches; });
  }
  body.querySelectorAll('table').forEach((table) => {
    const region = document.createElement('div');
    region.className = 'article-table-scroll';
    region.tabIndex = 0;
    region.setAttribute('role', 'region');
    region.setAttribute('aria-label', table.caption?.textContent.trim() || 'Article table');
    table.before(region);
    region.append(table);
  });
  body.querySelectorAll('img').forEach((image, index) => {
    const firstVisibleImage = index === 0 && !root.querySelector('.hero-image-media');
    image.loading = firstVisibleImage ? 'eager' : 'lazy';
    if (firstVisibleImage) image.fetchPriority = 'high';
    image.decoding = 'async';
  });
  body.querySelectorAll('iframe').forEach((frame) => {
    if (!frame.title) frame.title = 'Embedded article media';
    frame.loading = 'lazy';
  });
})();
